import { getComponent, hasComponent } from "../../world/Entity";
import type { Interaction } from "../Interaction";

export const openInteraction: Interaction = {
  id: "open",
  label: "Open",
  scope: "scene",
  canExecute: (ctx) => ctx.entity !== undefined && hasComponent(ctx.entity, "container"),
  execute: async (ctx) => {
    if (!ctx.entity) return { success: false };
    const container = getComponent(ctx.entity, "container")!;
    return {
      success: true,
      message: container.contains.length > 0 ? `Contains ${container.contains.length} item(s).` : "It's empty.",
    };
  },
};
